import * as Sentry from '@sentry/react';
import { RewriteFrames } from '@sentry/integrations';
import { DEPLOY_ENV } from 'utils/globals';

// From Webpack Define Plugin
// TODO: Switch to esbuild
declare global {
  const VERSION: string;
}

function init() {
  Sentry.init({
    dsn: 'https://a4afae1e484b44e39c99481d78ed2e18@o290440.ingest.sentry.io/1529933',
    // version constant from package.json
    release: VERSION,
    environment: DEPLOY_ENV,
    normalizeDepth: 10,
    ignoreErrors: [
      // safari extension errors
      '@webkit-masked-url',
    ],
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'xhr' && breadcrumb.data) {
        const analyticsRegex = /(clarity)*(analytics)*(doubleclick)*/gi;
        if (analyticsRegex.test(breadcrumb.data.url)) {
          return null;
        }
      }

      return breadcrumb;
    },
    integrations: [
      new RewriteFrames({
        /*
         * We need to remove the rails-generated fingerprint hash from the
         * stack trace source file so sentry knows to compare the correct
         * index.bundle.js to its index.bundle.map.js file
         */
        iteratee: (frame) => {
          if (!frame.filename) {
            return frame;
          }

          // eslint-disable-next-line no-param-reassign
          frame.filename = frame.filename.replace(/(bundle-[\w\d]*)/, 'bundle');
          return frame;
        },
      }),
    ],
  });
}

export default {
  init,
  addBreadcrumb: Sentry.addBreadcrumb,
  captureException: Sentry.captureException,
  captureMessage: Sentry.captureMessage,
  setUser: Sentry.setUser,
  setTag: Sentry.setTag,
  createReduxEnhancer: Sentry.createReduxEnhancer,
};
